export default "__VITE_ASSET__DALPahfT__"